import * as paths from "./paths";
import { store } from "../store/index.js";
export const Eurosport = "Eurosport";
export const Max = "HBO Max";
export const EurosportPlayer = "Eurosport Player";
export const DiscoveryPlus = "discovery+";
export const GCN = "Global Cycling Network";
export const GTV = "GolfTV";

export const convenience = "Cancel For Convenience";
export const cause = "Cancel For Cause";
export const addressChange = "Changement d’adresse";
export const situationChange = "Changement de situation familiale";

export const waterGazBill = "facture_eau-gaz-electricite";
export const phoneBill = "facture_telephone";
export const rentReceipt = "quittance-loyer";
export const bankOrCredit = "releve_bancaire-credit";
export const homeInsurance = "declaration-assurance-habitation";
export const pacs = "certificat-pacs";
export const marriage = "certificat-mariage";
export const death = "certificat_deces_livret-famille";
export const administrationRequest = "demande_naissance-depart-enfant";

export const germany_dplus_en = "germany_dplus_en";
export const germany_dplus_de = "germany_dplus_de";
export const germany_hbomax_en = "germany_hbomax_en";
export const germany_hbomax_de = "germany_hbomax_de";
export const france_dplus_en = "france_dplus_en";
export const france_dplus_fr = "france_dplus_fr";
export const france_hbomax_en = "france_hbomax_en";
export const france_hbomax_fr = "france_hbomax_fr";
export const canada_dplus_en = "canada_dplus_en";
export const canada_dplus_fr = "canada_dplus_fr";
export const fallbackLng = "fallbackLng";

export const en = "en";

export const homeUrls = (folder) => {
  let EurosportUrl,
    MaxUrl,
    GcnUrl,
    EurosportPlayerUrl,
    DiscoveryPlusUrl,
    GTVUrl = "";
  switch (folder) {
    case paths.subDomainFrance:
      EurosportUrl = "https://www.eurosport.fr/";
      MaxUrl = "https://www.max.com/";
      GcnUrl = "https://plus.globalcyclingnetwork.com/fr";
      EurosportPlayerUrl = "https://www.eurosportplayer.com/";
      DiscoveryPlusUrl = "https://www.discoveryplus.com";
      GTVUrl = "https://www.golf.tv/";
      break;
    case paths.subDomainCanada:
      EurosportUrl = "https://www.eurosport.com";
      GcnUrl = "https://plus.globalcyclingnetwork.com";
      EurosportPlayerUrl = "https://www.eurosportplayer.com/";
      DiscoveryPlusUrl = "https://www.discoveryplus.com";
      GTVUrl = "https://www.golf.tv/";
      break;
    default:
      EurosportUrl = "https://www.eurosport.de/";
      MaxUrl = "https://www.max.com/";
      GcnUrl = "https://plus.globalcyclingnetwork.com/de";
      EurosportPlayerUrl = "https://www.eurosportplayer.com/";
      DiscoveryPlusUrl = "https://www.discoveryplus.com";
      GTVUrl = "https://www.golf.tv/";
      break;
  }
  return {
    [Eurosport]: EurosportUrl,
    [Max]: MaxUrl,
    [EurosportPlayer]: EurosportPlayerUrl,
    [GCN]: GcnUrl,
    [DiscoveryPlus]: DiscoveryPlusUrl,
    [GTV]: GTVUrl,
  };
};

export const pdfLogoPaths = {
  [Eurosport]: {
    path: "/png/eurosport.png",
    height: "25px",
    width: "179px",
  },
  [Max]: {
    path: "/png/max.png",
    height: "62px",
    width: "86px",
  },
  [EurosportPlayer]: {
    path: "/png/eurosportPlayer.png",
    height: "39px",
    width: "250px",
  },
  [DiscoveryPlus]: {
    path: "/png/dplus.png",
    height: "58px",
    width: "70px",
  },
  [GTV]: {
    path: "/png/gtv.png",
    height: "20px",
    width: "132px",
  },
  [GCN]: {
    path: "/png/gcn.png",
    height: "48px",
    width: "161px",
  },
};

export const helpCenterUrls = (folder) => {
  let EurosportUrl,
    MaxUrl,
    GcnUrl,
    EurosportPlayerUrl,
    DiscoveryPlusUrl,
    GTVUrl = "";

  switch (folder) {
    case paths.subDomainFrance:
      MaxUrl = "https://help.max.com/fr/";
      EurosportUrl = "https://help.eurosport.com/hc/fr";
      GcnUrl = "https://help.globalcyclingnetwork.com/hc/en-gb";
      EurosportPlayerUrl = "https://help.eurosport.com/hc/fr";
      DiscoveryPlusUrl = "https://support.discoveryplus.com/hc/en-gb";
      GTVUrl = "https://help.golf.tv/hc/fr";
      break;
    case paths.subDomainCanada:
      MaxUrl = "https://help.max.com/fr/";
      EurosportUrl = "https://help.eurosport.com/hc/fr";
      GcnUrl = "https://help.globalcyclingnetwork.com/hc/en-gb";
      EurosportPlayerUrl = "https://help.eurosport.com/hc/fr";
      DiscoveryPlusUrl =
        store.getState().form.local === canada_dplus_fr
          ? "https://help.discoveryplus.com/hc/fr-ca"
          : "https://help.discoveryplus.com/hc/en-ca";
      GTVUrl = "https://help.golf.tv/hc/de/";
      break;
    default:
      MaxUrl = "https://help.hbomax.com/de/";
      EurosportUrl = "https://help.eurosport.com/hc/de";
      GcnUrl = "https://help.globalcyclingnetwork.com/hc/en-gb";
      EurosportPlayerUrl = "https://help.eurosport.com/hc/de";
      DiscoveryPlusUrl = "https://support.discoveryplus.com/hc/de";
      GTVUrl = "https://help.golf.tv/hc/de/";
      break;
  }
  return {
    [Eurosport]: EurosportUrl,
    [Max]: MaxUrl,
    [EurosportPlayer]: EurosportPlayerUrl,
    [GCN]: GcnUrl,
    [DiscoveryPlus]: DiscoveryPlusUrl,
    [GTV]: GTVUrl,
  };
};

export const accountSettingsUrls = () => {
  return {
    [Max]: "https://auth.hbomax.com/subscription",
    [DiscoveryPlus]: "https://auth.discoveryplus.com/subscription",
  };
};

export const brandDTO = {
  [Eurosport]: "eurosport",
  [Max]: "HBO Max",
  [EurosportPlayer]: "eurosportplayer",
  [DiscoveryPlus]: "discovery+",
  [GCN]: "globalcyclingnetwork",
  [GTV]: "golftv",
};

export const cancellationReasonDTO = {
  [convenience]: "convenience",
  [cause]: "cause",
  [addressChange]: "change-address",
  [situationChange]: "change-tax-household",
};

export const cancellationReasonCanadaDTO = {
  [convenience]: "nextBillingDate",
  [cause]: "legitimateReason",
};

export const folderMappingLanguage = {
  [paths.subDomainGermany + paths.brand_dplus]: germany_dplus_de,
  [paths.subDomainGermany + paths.brand_dplus + en]: germany_dplus_en,
  [paths.subDomainGermany + paths.brand_max]: germany_hbomax_de,
  [paths.subDomainGermany + paths.brand_max + en]: germany_hbomax_en,
  [paths.subDomainFrance + paths.brand_dplus]: france_dplus_fr,
  [paths.subDomainFrance + paths.brand_dplus + en]: france_dplus_en,
  [paths.subDomainFrance + paths.brand_max]: france_hbomax_fr,
  [paths.subDomainFrance + paths.brand_max + en]: france_hbomax_en,
  [paths.subDomainCanada + paths.brand_dplus]: canada_dplus_fr,
  [paths.subDomainCanada + paths.brand_dplus + en]: canada_dplus_en,
};

export const folderMappingPayloadCountry = {
  [paths.subDomainFrance]: "France",
  [paths.subDomainGermany]: "Germany",
  [paths.subDomainCanada]: "Canada",
};

export const LanguageMappingPayload = {
  [germany_dplus_en]: "en_US",
  [germany_dplus_de]: "de",
  [germany_hbomax_en]: "en_US",
  [germany_hbomax_de]: "de",
  [france_dplus_en]: "en_US",
  [france_dplus_fr]: "fr",
  [france_hbomax_en]: "en_US",
  [france_hbomax_fr]: "fr",
  [canada_dplus_en]: "en_canada",
  [canada_dplus_fr]: "fr_canada",
  [fallbackLng]: "Germany",
};

export const lookupPerCountry = {
  [paths.subDomainFrance + paths.brand_dplus]: {
    [france_dplus_fr]: "Français (FR)",
    [france_dplus_en]: "English (GB)",
  },
  [paths.subDomainFrance + paths.brand_max]: {
    [france_hbomax_fr]: "Français (FR)",
    [france_hbomax_en]: "English (GB)",
  },
  [paths.subDomainGermany + paths.brand_dplus]: {
    [germany_dplus_de]: "Deutsche",
    [germany_dplus_de]: "English (GB)",
  },
  [paths.subDomainGermany + paths.brand_max]: {
    [germany_hbomax_de]: "Deutsche",
    [germany_hbomax_en]: "English (GB)",
  },
  [paths.subDomainCanada + paths.brand_dplus]: {
    [canada_dplus_fr]: "Français (Canada)",
    [canada_dplus_en]: "English (Canada)",
  },
};

export const lookup = {
  [germany_dplus_en]: "English (GB)",
  [germany_dplus_de]: "Deutsche",
  [germany_hbomax_en]: "English (GB)",
  [germany_hbomax_de]: "Deutsche",
  [france_dplus_en]: "English (GB)",
  [france_dplus_fr]: "Français (FR)",
  [france_hbomax_en]: "English (GB)",
  [france_hbomax_fr]: "Français (FR)",
  [canada_dplus_en]: "English (Canada)",
  [canada_dplus_fr]: "Français (Canada)",
};
